import React from 'react'
import InviteHandler from './src/components/InviteHandler'
import { ThemeProvider, withTheme } from '@material-ui/styles'
class Components extends React.Component {
	render = () => <ThemeProvider theme={this.props.theme}><InviteHandler/></ThemeProvider>
}
export default withTheme(Components)